import { render, staticRenderFns } from "./NewASorRbuItemDialog.vue?vue&type=template&id=788800d0"
import script from "./NewASorRbuItemDialog.vue?vue&type=script&lang=js"
export * from "./NewASorRbuItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports